import { UseQueryResult } from '@tanstack/react-query';

export const getQueriesSummary = (queries: UseQueryResult[]) => {
  const counts = queries.reduce(
    (acc, query) => {
      acc[query.status]++;
      return acc;
    },
    {
      error: 0,
      pending: 0,
      success: 0,
    }
  );

  const status: UseQueryResult['status'] =
    counts.error > 0 ? 'error' : counts.pending > 0 ? 'pending' : 'success';

  return {
    counts,
    status,
  };
};
